/**
 * Bulletproof error extractor for axios responses.
 *
 * FastAPI/Pydantic returns 422 validation errors as
 *   detail: Array<{ type, loc, msg, input, ctx, url }>
 * Passing that array directly into `toast.error(...)` or any JSX child
 * crashes React 18+ with "Minified React error #31". Always pipe server
 * errors through this so an array-of-objects becomes a readable string.
 *
 * Founder incident 2026-02-27: Production white-screen on Custom Video
 * Generate. The 422 itself was a request schema mismatch; the *crash* was
 * the unhandled detail-array hitting React. This helper makes that crash
 * impossible.
 */
export function errMsg(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d.length) {
    return (
      d
        .map((v) => (typeof v === "string" ? v : v?.msg || ""))
        .filter(Boolean)
        .join(" · ") || fallback
    );
  }
  if (d && typeof d === "object") {
    return d.msg || d.message || JSON.stringify(d).slice(0, 200);
  }
  return e?.message || fallback;
}
